import { useMemo } from 'react'

import placeholder from '../assets/images/avatar.png'

export const useDefaultAvatar = (image?: string, isValid?: boolean) => {
  return useMemo(() => {
    if (isValid && image) {
      return image
    }

    return placeholder
  }, [image, isValid])
}
